<style scoped lang="less">
</style>
<template>
	<div>
		<titles titlename="我的学习地图执行情况管理" titlecontent="这里可以看到学习地图执行情况管理" :mbx="paths"></titles>
		
	</div>
</template>

<script>
	import titles from "@/components/title/title.vue"
	
	export default{
		data(){
			return{
				// 标题
				paths: [{
					path: "/homesview/Learnaboutmap",
					name: "这里可以看到学习地图执行情况管理"
				}],
			}
		},
		components: {
			titles
		}
		
	}
	
	
</script>

